import { Injectable } from '@angular/core';
import { Apollo, Mutation } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { gql } from 'apollo-angular';
import { Exact } from 'src/generated/graphql';

export type UpdateScoringCriteriaMutationVariables = Exact<{
  id: number; 
  data: {
    remunerationId: number;
    scoreLevelId: number;
    minValue: number | null;
    maxValue: number | null;
    points: number;
  };
}>;

export type UpdateScoringCriteriaMutation = {
  updateScoringCriteria: {
    id: string;
  };
};

@Injectable({
  providedIn: 'root',
})
export class UpdateScoringCriteriaGQL extends Mutation<
  UpdateScoringCriteriaMutation,
  UpdateScoringCriteriaMutationVariables
> {
  document = gql`
    mutation UpdateScoringCriteria($id: Float!, $data: UpdateScoringCriteriaDto!) {
      updateScoringCriteria(id: $id, data: $data) {
        id
      }
    }
  `;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
